export default __webpack_public_path__ + "static/media/PUP.b89a77c1.png";